import React, {FC} from 'react'

import PFText from 'src/designSystem/components/atoms/PFText/PFText'
import Page from 'src/designSystem/components/organisms/Page/Page'
import {AppEvents} from 'src/lib/Analytics/app_events'
import {usePageViewedAnalytics} from 'src/lib/Analytics/usePageViewedAnalytics'
import {useTranslation} from 'react-i18next'
// this page lives on Routes.tsx and is not part of workflows
const MilitaryNotEligible: FC = () => {
  const {t} = useTranslation(['MilitarySurvey'])

  usePageViewedAnalytics({
    eventName: AppEvents.Name.ineligible_due_to_military_status_screen_viewed,
    eventCategory: AppEvents.Category.Onboarding,
    eventArgs: {
      navContainerType: 'Routes.tsx',
    },
  })

  return (
    <Page
      variant="generic"
      smallTopGap={true}
      testID="MilitaryNotEligiblePage"
      title={t('MilitaryNotEligibleTitle')}
    >
      <PFText variant="p">{t('MilitaryNotEligibleDescription')}</PFText>
    </Page>
  )
}

export {MilitaryNotEligible}
